import { Flex, Spacer, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { withTranslation } from '../../with_translation';
import { QRCodeSVG } from 'qrcode.react';
import { KioskSessionFlow, SessionController } from '../../session.controller';
import { useResolve } from '@visiba/instantiation';

interface Props {}

export function ThankYou(_: Props): JSX.Element {
	const controller = useResolve(SessionController);

	return (
		<div style={{ textAlign: 'center' }}>
			<Spacer vertical={tokens.spacing.x8} />
			<Text.h1 variant='headingMedium'>{withTranslation('thank-you.title')}</Text.h1>
			<Spacer vertical={tokens.spacing.x4} />
			<Text.p variant='bodyRegular'>{withTranslation('thank-you.description')}</Text.p>
			{controller.sessionFlow === KioskSessionFlow.QrCode ? (
				<>
					<Spacer vertical={tokens.spacing.x4} />
					<Flex direction='row' justify='center'>
						<QRCodeSVG
							size={256}
							value={`19121212-1212`}
							fgColor='#192851'
							level='Q'
							imageSettings={{ src: '/qr_logo.png', height: 80, width: 80, excavate: false }}
						/>
					</Flex>
				</>
			) : null}
		</div>
	);
}
